export enum DentalHistoryChartFields {
  Symptom1 = 'symptom1',
  Symptom1Check = 'symptom1Check',
  Symptom1Text = 'symptom1Text',
  Symptom2 = 'symptom2',
  Symptom2Text = 'symptom2Text',
  Symptom3 = 'symptom3',
  Symptom3Check = 'symptom3Check',
  Symptom3Text = 'symptom3Text',
  Symptom4 = 'symptom4',
  Symptom4Check = 'symptom4Check',
  Symptom4Text = 'symptom4Text',
  Symptom5 = 'symptom5',
  Symptom5Check = 'symptom5Check',
  Symptom5Text = 'symptom5Text',
  Symptom6 = 'symptom6',
  Symptom6Text = 'symptom6Text',
  Symptom7 = 'symptom7',
  Symptom7Text = 'symptom7Text',
  Symptom8 = 'symptom8',
  Symptom8Check = 'symptom8Check',
  Symptom8Text = 'symptom8Text',
  Symptom9 = 'symptom9',
  Symptom9Text = 'symptom9Text',
  Symptom10 = 'symptom10',
  Symptom10Check = 'symptom10Check',
  Symptom10Text = 'symptom10Text',
  Symptom11 = 'symptom11',
  Symptom11Text = 'symptom11Text',
  Symptom12 = 'symptom12',
  Symptom12Check = 'symptom12Check',
  Symptom12Text = 'symptom12Text',
  Symptom13 = 'symptom13',
  Symptom13Text = 'symptom13Text',
  Symptom14 = 'symptom14',
  Symptom14Check = 'symptom14Check',
  Symptom14Text = 'symptom14Text',
  Symptom15 = 'symptom15',
  Symptom15Check = 'symptom15Check',
  Symptom15Text = 'symptom15Text',
  Symptom16 = 'symptom16',
  Symptom16Check = 'symptom16Check',
  Symptom16Text = 'symptom16Text',
  Symptom17 = 'symptom17',
  Symptom17Text = 'symptom17Text',
  LastScaling = 'lastScaling',
  CheckPoint = 'checkPoint',
  CheckPointDetail = 'checkPointDetail',
  BadExperience = 'badExperience',
  BadExperienceDetail = 'badExperienceDetail',
  DentalTreatment = 'dentalTreatment',
  DentalTreatmentDetail = 'dentalTreatmentDetail',
  DentalProblem = 'dentalProblem',
  DentalProblemDetail = 'dentalProblemDetail',
}

export enum Symptom {
  Symptom1 = '시린치아 (찬물, 따뜻한 물, 단것, 압력)',
  Symptom2 = '구강이 자주 건조함 (입술, 혀, 점막 등)',
  Symptom3 = '치아가 흔들리는 것 같다.',
  Symptom4 = '음식물이 치아사이에 자주 낀다.',
  Symptom5 = '잇몸에서 고름(농양)이 난다.',
  Symptom6 = '현재 구강에 아프타성 궤양(구내염)이 있다.',
  Symptom7 = '혀에 백태가 자주 낀다.',
  Symptom8 = '칫솔질 할 때 잇몸에서 피가 날 때가 있다.',
  Symptom9 = '이갈이 또는 악물이 하는 버릇이 있다.',
  Symptom10 = '턱관절이 아프거나 빠진 적이 있다.',
  Symptom11 = '입냄새(구취)가 난다.',
  Symptom12 = '칫솔질 또는 식사 할 때 잇몸(치아)가 아프다.',
  Symptom13 = '쉽게 구토를 하는 경향이 있다.',
  Symptom14 = '한쪽으로만 음식을 씹는 버릇이 있다.',
  Symptom15 = '구강 내 충전물이 탈락되어 있다.',
  Symptom16 = '저작 시 통증이 있다.',
  Symptom17 = '기타',
}

export const SymptomLabel = {
  [Symptom.Symptom1]: '시린치아 (찬물, 따뜻한 물, 단것, 압력)',
  [Symptom.Symptom2]: '구강이 자주 건조함 (입술, 혀, 점막 등)',
  [Symptom.Symptom3]: '치아가 흔들리는 것 같다.',
  [Symptom.Symptom4]: '음식물이 치아사이에 자주 낀다.',
  [Symptom.Symptom5]: '잇몸에서 고름(농양)이 난다.',
  [Symptom.Symptom6]: '현재 구강에 아프타성 궤양(구내염)이 있다.',
  [Symptom.Symptom7]: '혀에 백태가 자주 낀다.',
  [Symptom.Symptom8]: '칫솔질 할 때 잇몸에서 피가 날 때가 있다.',
  [Symptom.Symptom9]: '이갈이 또는 악물이 하는 버릇이 있다.',
  [Symptom.Symptom10]: '턱관절이 아프거나 빠진 적이 있다.',
  [Symptom.Symptom11]: '입냄새(구취)가 난다.',
  [Symptom.Symptom12]: '칫솔질 또는 식사 할 때 잇몸(치아)가 아프다.',
  [Symptom.Symptom13]: '쉽게 구토를 하는 경향이 있다.',
  [Symptom.Symptom14]: '한쪽으로만 음식을 씹는 버릇이 있다.',
  [Symptom.Symptom15]: '구강 내 충전물이 탈락되어 있다.',
  [Symptom.Symptom16]: '저작 시 통증이 있다.',
  [Symptom.Symptom17]: '기타',
};

export enum LastScaling {
  Scaling1 = '약 6개월 전',
  Scaling2 = '약 1년 - 2년 전',
  Scaling3 = '약 3년 이상',
  Scaling4 = '받은 적 없음',
}

export const LastScalingLabel = {
  [LastScaling.Scaling1]: '약 6개월 전',
  [LastScaling.Scaling2]: '약 1년 - 2년 전',
  [LastScaling.Scaling3]: '약 3년 이상',
  [LastScaling.Scaling4]: '받은 적 없음',
};

export const LastScalingList = [
  {
    label: LastScalingLabel[LastScaling.Scaling1],
    value: LastScaling.Scaling1,
  },
  {
    label: LastScalingLabel[LastScaling.Scaling2],
    value: LastScaling.Scaling2,
  },
  {
    label: LastScalingLabel[LastScaling.Scaling3],
    value: LastScaling.Scaling3,
  },
  {
    label: LastScalingLabel[LastScaling.Scaling4],
    value: LastScaling.Scaling4,
  },
];

export enum CheckPoint {
  Check1 = '처치 시 두려움에 대한 이해',
  Check2 = '소요시간/시간 준수',
  Check3 = '처치과정에 대한 설명',
  Check4 = '긴장감에 대한 해소',
  Check5 = '관심_기타',
}

export const CheckPointLabel = {
  [CheckPoint.Check1]: '처치 시 두려움에 대한 이해',
  [CheckPoint.Check2]: '소요시간/시간 준수',
  [CheckPoint.Check3]: '처치과정에 대한 설명',
  [CheckPoint.Check4]: '긴장감에 대한 해소',
  [CheckPoint.Check5]: '기타',
};

export enum DentalHistoryChartRadioBtn {
  Yes = '예',
  No = '아니요',
}

export const DentalHistoryChartRadioBtnLabel = {
  [DentalHistoryChartRadioBtn.Yes]: '예',
  [DentalHistoryChartRadioBtn.No]: '아니요',
};

export enum DentalTreatment {
  Treatment1 = '교정치료',
  Treatment2 = '임플란트 치료',
  Treatment3 = '잇몸수술',
  Treatment4 = '부분의치 / 총의치',
  Treatment5 = '충치치료',
  Treatment6 = '턱관절치료',
  Treatment7 = '미백치료',
  Treatment8 = '양악수술',
  Treatment9 = '신경치료',
  Treatment10 = '두경부 방사선치료',
  Treatment11 = '치과치료_기타',
}

export const DentalTreatmentLabel = {
  [DentalTreatment.Treatment1]: '교정치료',
  [DentalTreatment.Treatment2]: '임플란트 치료',
  [DentalTreatment.Treatment3]: '잇몸수술',
  [DentalTreatment.Treatment4]: '부분의치 / 총의치',
  [DentalTreatment.Treatment5]: '충치치료',
  [DentalTreatment.Treatment6]: '턱관절치료',
  [DentalTreatment.Treatment7]: '미백치료',
  [DentalTreatment.Treatment8]: '양악수술',
  [DentalTreatment.Treatment9]: '신경치료',
  [DentalTreatment.Treatment10]: '두경부 방사선치료',
  [DentalTreatment.Treatment11]: '기타',
};

export enum DentalProblem {
  Problem1 = '누렇거나 회색의 치아',
  Problem2 = '치아사이가 벌어짐',
  Problem3 = '구취',
  Problem4 = '치아착색',
  Problem5 = '부정교합',
  Problem6 = '구강과 관련한 얼굴외모',
  Problem7 = '잇몸의 형태',
  Problem8 = '구강문제_기타',
}

export const DentalProblemLabel = {
  [DentalProblem.Problem1]: '누렇거나 회색의 치아',
  [DentalProblem.Problem2]: '치아사이가 벌어짐',
  [DentalProblem.Problem3]: '구취',
  [DentalProblem.Problem4]: '치아착색',
  [DentalProblem.Problem5]: '부정교합',
  [DentalProblem.Problem6]: '구강과 관련한 얼굴외모',
  [DentalProblem.Problem7]: '잇몸의 형태',
  [DentalProblem.Problem8]: '기타',
};

export const DentalHistoryChartFormDefaultValues = {
  [DentalHistoryChartFields.Symptom1]: '',
  [DentalHistoryChartFields.Symptom1Check]: [],
  [DentalHistoryChartFields.Symptom1Text]: '',
  [DentalHistoryChartFields.Symptom2]: '',
  [DentalHistoryChartFields.Symptom2Text]: '',
  [DentalHistoryChartFields.Symptom3]: '',
  [DentalHistoryChartFields.Symptom3Check]: [],
  [DentalHistoryChartFields.Symptom3Text]: '',
  [DentalHistoryChartFields.Symptom4]: '',
  [DentalHistoryChartFields.Symptom4Check]: [],
  [DentalHistoryChartFields.Symptom4Text]: '',
  [DentalHistoryChartFields.Symptom5]: '',
  [DentalHistoryChartFields.Symptom5Check]: [],
  [DentalHistoryChartFields.Symptom5Text]: '',
  [DentalHistoryChartFields.Symptom6]: '',
  [DentalHistoryChartFields.Symptom6Text]: '',
  [DentalHistoryChartFields.Symptom7]: '',
  [DentalHistoryChartFields.Symptom7Text]: '',
  [DentalHistoryChartFields.Symptom8]: '',
  [DentalHistoryChartFields.Symptom8Check]: [],
  [DentalHistoryChartFields.Symptom8Text]: '',
  [DentalHistoryChartFields.Symptom9]: '',
  [DentalHistoryChartFields.Symptom9Text]: '',
  [DentalHistoryChartFields.Symptom10]: '',
  [DentalHistoryChartFields.Symptom10Check]: [],
  [DentalHistoryChartFields.Symptom10Text]: '',
  [DentalHistoryChartFields.Symptom11]: '',
  [DentalHistoryChartFields.Symptom11Text]: undefined,
  [DentalHistoryChartFields.Symptom12]: '',
  [DentalHistoryChartFields.Symptom12Check]: [],
  [DentalHistoryChartFields.Symptom12Text]: '',
  [DentalHistoryChartFields.Symptom13]: '',
  [DentalHistoryChartFields.Symptom13Text]: '',
  [DentalHistoryChartFields.Symptom14]: '',
  [DentalHistoryChartFields.Symptom14Check]: [],
  [DentalHistoryChartFields.Symptom14Text]: '',
  [DentalHistoryChartFields.Symptom15]: '',
  [DentalHistoryChartFields.Symptom15Check]: [],
  [DentalHistoryChartFields.Symptom15Text]: '',
  [DentalHistoryChartFields.Symptom16]: '',
  [DentalHistoryChartFields.Symptom16Check]: [],
  [DentalHistoryChartFields.Symptom16Text]: '',
  [DentalHistoryChartFields.Symptom17]: '',
  [DentalHistoryChartFields.Symptom17Text]: '',
  [DentalHistoryChartFields.LastScaling]: undefined,
  [DentalHistoryChartFields.CheckPoint]: [],
  [DentalHistoryChartFields.CheckPointDetail]: '',
  [DentalHistoryChartFields.BadExperience]: undefined,
  [DentalHistoryChartFields.BadExperienceDetail]: '',
  [DentalHistoryChartFields.DentalTreatment]: [],
  [DentalHistoryChartFields.DentalTreatmentDetail]: '',
  [DentalHistoryChartFields.DentalProblem]: [],
  [DentalHistoryChartFields.DentalProblemDetail]: '',
};
